import { ERROR_CODES } from '../errors/error-codes';
import { LOCALES } from './enums';
/**
 * QR ile kartvizit değişiminin ORTAK KURALLARI (Faz 3 — Blok 20).
 *
 * Bu dosya Joi'SİZDİR ve kök barrel'dan çıkar: mobil, web ve API aynı jeton
 * biçimini, aynı kısa kod alfabesini ve aynı "onay öncesi alan kümesini" tek
 * kaynaktan okur. Mobil ekranlar (Akış C) Blok 19'da bu biçimlerle yazıldı;
 * sözleşme ONLARA uyduruldu, tersi değil.
 *
 * KIRMIZI ÇİZGİ 1 (CLAUDE.md): kart değişimi ÇİFT TARAFLI onaylıdır. Buradaki
 * `isCardExchangeMutuallyConfirmed` yalnızca İSTEMCİ görünümünü hesaplar —
 * gerçek kapı veritabanındadır (`ck_encounters_mutual_consent` +
 * `encounter_mutual_consent_guard` trigger'ı). Bu fonksiyon kaldırılsa bile
 * tek onaylı bir karşılaşma satırı YAZILAMAZ.
 */
/**
 * Kart paylaşım jetonunun öneki. Yaka kartı jetonundan (`ibk1_`) AYRI bir
 * uzaydır: kapıdaki bilet QR'ı ile kartvizit QR'ı aynı kamerada karışmasın.
 */
export const CARD_SHARE_TOKEN_PREFIX = 'ibc1_';
/** Jetonun önekten sonraki rastgele gövdesi (base64url, 32 karakter ≈ 192 bit). */
export const CARD_SHARE_TOKEN_BODY_LENGTH = 32;
/**
 * Jeton KISA ÖMÜRLÜDÜR ve her istekte döner (Story 17.1: "QR yükünde kalıcı
 * kullanıcı/kart kimliği yoktur"). Ekran açık kalırken süresi dolarsa istemci
 * yeniden ister; kalıcı bir kart kimliği asla QR'a yazılmaz.
 */
export const CARD_SHARE_TOKEN_TTL_SECONDS = 600;
/** Teklifin ömrü (D3): onaylanmayan teklif süresi dolunca `expired` olur. */
export const CARD_EXCHANGE_OFFER_TTL_SECONDS = 900;
/**
 * Elle girilen kısa kod (referans: "örn. 4K7-92B"). Karışan karakterler
 * (O/0, I/1) alfabeden ÇIKARILDI: loş salonda yanlış okunan tek harf yanlış
 * kişiyi getirir.
 */
export const MANUAL_CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
export const MANUAL_CODE_GROUP = 3;
export const MANUAL_CODE_LENGTH = MANUAL_CODE_GROUP * 2;
export function isCardShareToken(value) {
    const trimmed = value.trim();
    return (trimmed.startsWith(CARD_SHARE_TOKEN_PREFIX) && trimmed.length > CARD_SHARE_TOKEN_PREFIX.length);
}
/* ------------------------------------------------------------------------- *
 * KAREKOD İÇERİĞİ: HAM JETON YA DA ORTAMIN ADRESİ (karekod kapsamı 02.11.2026)
 * ------------------------------------------------------------------------- */
/**
 * Adresli karekodun yolu: `https://<ortam>/kart/<jeton>`. `/k/` KULLANILMAZ,
 * o yol kalıcı kart bağlantısınındır (farklı jeton türü). `/kart/` canlıdaki
 * uygulama bağlantısı belgelerinde zaten uygulamaya verilen yoldur.
 */
export const CARD_SHARE_QR_PATH = 'kart';
/** Yoğun karekod loş salonda okunmaz: adresli içerik bu uzunluğu GEÇMEZ. */
export const CARD_SHARE_QR_MAX_LENGTH = 80;
/** Sunucunun ürettiği jetonun tam biçimi (base64url gövde, sabit uzunluk). */
const CARD_SHARE_TOKEN_EXACT = new RegExp(`^${CARD_SHARE_TOKEN_PREFIX}[A-Za-z0-9_-]{${CARD_SHARE_TOKEN_BODY_LENGTH}}$`);
/** İzinli köken biçimi: şema + küçük harfli alan (+ isteğe bağlı port), sonda eğik çizgi YOK. */
export const CARD_SHARE_QR_ORIGIN_SHAPE = /^https?:\/\/[a-z0-9.-]+(?::\d{1,5})?$/;
/** Adresli karekod içeriği. `origin` ortamın public web kökenidir (`https://warmbreak.com`). */
export function cardShareQrUrl(origin, token) {
    return `${origin}/${CARD_SHARE_QR_PATH}/${token}`;
}
/**
 * KAREKOD DEĞERİNDEN DEĞİŞİM JETONU — TEK ORTAK BİÇİM KURALI.
 *
 * Kartvizit karekodu okuyan HER yüzey (web, iOS, Android, API teklif ucu)
 * okunan değeri buradan geçirir; kural çoğaltılmaz (okuyucu envanteri kapısı
 * `card-share-qr-reader.guard.spec.ts`).
 *
 * KABUL:
 *  - ham jeton (`ibc1_…`, bugünkü biçim, `isCardShareToken` ile AYNI gevşeklikte:
 *    eski sürümlerin gösterdiği karekod birebir okunur),
 *  - `<izinli köken>/kart/<jeton>` ve dil önekli `<izinli köken>/<tr|en>/kart/<jeton>`.
 *    Adresteki jeton sunucunun ürettiği TAM biçimde olmak zorundadır.
 *
 * RET (hepsi `null`): başka köken, `www.`, başka ortamın kökeni, port ya da
 * şema farkı, `/kart/degisim`, `/k/<…>`, yaka kartı jetonu (`ibk1_`), sorgu,
 * parça, sondaki eğik çizgi, çift eğik çizgi, yüzde kodlaması, büyük harfli
 * şema/alan/yol. Sunucu adresi HER ZAMAN aynı küçük harfli biçimde üretir;
 * varyant kabul etmek yalnız saldırı yüzeyi açar.
 *
 * `allowedOrigins` çağıranın KENDİ ortamıdır (web `window.location.origin`,
 * mobil derlemenin alanı, API `APP_WEB_URL` kökeni). Biçimsiz köken girdisi
 * (sonda eğik çizgi, büyük harf, yol) yok sayılır: kural kapalı tarafa düşer.
 * Karekod dışarıdan gelen veridir; bu işlev hiçbir adresi AÇMAZ, yalnız okur.
 */
export function extractCardShareToken(qrValue, allowedOrigins) {
    const value = qrValue.trim();
    if (isCardShareToken(value))
        return value;
    for (const origin of allowedOrigins) {
        if (!CARD_SHARE_QR_ORIGIN_SHAPE.test(origin))
            continue;
        if (!value.startsWith(`${origin}/`))
            continue;
        const rest = value.slice(origin.length).split('/');
        // rest[0] '' (köken sonrası ilk eğik çizgi); kalan: [locale?, 'kart', jeton]
        const segments = rest.slice(1);
        const withLocale = segments.length === 3;
        if (!withLocale && segments.length !== 2)
            continue;
        const [first, second, third] = segments;
        if (withLocale && !LOCALES.includes(first ?? ''))
            continue;
        const path = withLocale ? second : first;
        const token = withLocale ? third : second;
        if (path !== CARD_SHARE_QR_PATH || token === undefined)
            continue;
        if (CARD_SHARE_TOKEN_EXACT.test(token))
            return token;
    }
    return null;
}
export function normalizeManualCode(input) {
    const cleaned = input
        .toLocaleUpperCase('en-US')
        .split('')
        .filter((character) => MANUAL_CODE_ALPHABET.includes(character))
        .join('');
    const head = cleaned.slice(0, MANUAL_CODE_GROUP);
    const tail = cleaned.slice(MANUAL_CODE_GROUP, MANUAL_CODE_LENGTH);
    return tail.length > 0 ? `${head}-${tail}` : head;
}
/**
 * BİÇİMLENDİRME SONRASI İMLEÇ (web elle kod, 13.10.2026).
 *
 * `normalizeManualCode` her tuşta değeri yeniden yazar; denetimli alan imleci
 * sona atar ve ortadan düzenleme bozulur. İmlecin SOLUNDAKİ anlamlı karakter
 * sayısı (normalizasyondan sağ çıkanlar, kod uzunluğuyla kırpılır) yeni dizide
 * aynı mantıksal konuma çevrilir: ayırıcı `-` eklenip kalkınca kaymaz.
 */
export function manualCodeCaret(raw, caret) {
    const left = raw.slice(0, Math.max(caret, 0));
    const significant = Math.min(normalizeManualCode(left).replace('-', '').length, MANUAL_CODE_LENGTH);
    // İmleç ayırıcının hemen sağındaysa orada kalır (ilk grup tamamken).
    const afterSeparator = significant === MANUAL_CODE_GROUP && left.endsWith('-');
    const position = significant > MANUAL_CODE_GROUP || afterSeparator ? significant + 1 : significant;
    return Math.min(position, normalizeManualCode(raw).length);
}
export function isValidManualCode(input) {
    return /^[A-Z2-9]{3}-[A-Z2-9]{3}$/.test(normalizeManualCode(input));
}
/**
 * ARDIŞIK HATALI KOD DENEMESİNDEN SONRA YOL GÖSTERİLİR (mobil Blok 22, web
 * 12.10.2026 · iki yüzey AYNI eşiği okur).
 *
 * Sunucu kilidi (`MANUAL_CODE_FAILURE_THRESHOLD`) yanıttan OKUNAMAZ: kilidin
 * yanıtı diğer retlerle birebir aynıdır. Kamerası olmayan kullanıcı için elle
 * kod tek yoldur ve kilit mesajı ona yapamayacağı şeyi söyler ("Kodu yeniden
 * okut"). İstemci KENDİ başarısız denemelerini sayar ve eşiği geçince gerçek
 * çıkışı öne alır: kartını göster, karşı taraf senin kodunu okutsun.
 *
 * Eşik sunucununkinden KÜÇÜKTÜR: yol, kullanıcı kilide girmeden gösterilir.
 */
export const MANUAL_CODE_HINT_AFTER_FAILURES = 3;
export function shouldPromoteShowCard(consecutiveFailures) {
    return consecutiveFailures >= MANUAL_CODE_HINT_AFTER_FAILURES;
}
export function manualCodeErrorKind(error) {
    if (!error)
        return null;
    if (error.statusCode === 0)
        return 'network';
    if (error.statusCode === 429 || error.code === ERROR_CODES.RATE_LIMITED)
        return 'rateLimited';
    if (error.code === ERROR_CODES.CARD_EXCHANGE_SELF)
        return 'self';
    if (error.code === ERROR_CODES.CARD_EXCHANGE_UNAVAILABLE || error.statusCode === 404)
        return 'unavailable';
    if (error.code === ERROR_CODES.VALIDATION_FAILED || error.statusCode === 400)
        return 'invalid';
    return 'other';
}
/**
 * D2 — ONAY ÖNCESİ ALAN KÜMESİ KİLİTLİ.
 *
 * Karşı tarafın onayı gelmeden istemciye dönebilecek TEK alan kümesi budur.
 * Liste sözleşmenin kendisidir: `contracts/encounter.ts` içindeki
 * `ExchangeCardPreviewDto` tip düzeyinde bu listeye bağlanmıştır (fazla ya da
 * eksik alan DERLEMEYİ kırar) ve `card-exchange-preview.spec.ts` alan alan
 * doğrular.
 */
export const EXCHANGE_PREVIEW_FIELDS = [
    'userId',
    'cardId',
    'displayName',
    'jobTitle',
    'companyName',
    'avatarUrl',
    'interestTags',
];
/**
 * İLETİŞİM SINIFI — onay öncesi HİÇBİR yanıtta bulunamaz (D2). Kalıcı tarama
 * (`card-exchange-preview.spec.ts`) bu listeyi kullanarak hem sözleşmeyi hem de
 * uçtan dönen gövdeyi denetler; yeni bir iletişim alanı eklenirse buraya da
 * eklenir, yoksa tarama boşluğa düşer.
 */
export const EXCHANGE_FORBIDDEN_PREVIEW_FIELDS = [
    'email',
    'phone',
    'websiteUrl',
    'linkedinUrl',
    'xUrl',
    'githubUrl',
    'bio',
    'educationSchool',
    'educationField',
    'educationGraduationYear',
];
/** İki onay damgası da doluysa TRUE. Tek taraf yeterli DEĞİLDİR. */
export function isCardExchangeMutuallyConfirmed(exchange) {
    return exchange.initiatorConfirmedAt !== null && exchange.recipientConfirmedAt !== null;
}
/** Teklif kanalı → karşılaşma kanalı. Elle kod da QR ile aynı akıştır, kanalı ayrıdır. */
export function encounterChannelFor(channel) {
    if (channel === 'manual_code')
        return 'manual';
    if (channel === 'link')
        return 'link';
    return 'qr';
}
/* ------------------------------------------------------------------------- *
 * KÖTÜYE KULLANIM KAPILARI (Blok 21 — Story 17.3)
 * ------------------------------------------------------------------------- */
/**
 * Kısa kodun ARAMA UZAYI. Ölçüm raporda kullanılır ve testte doğrulanır:
 * uzay ya da uzunluk değişirse kaba kuvvet hesabı YENİDEN yapılmalıdır.
 */
export const MANUAL_CODE_KEYSPACE = MANUAL_CODE_ALPHABET.length ** MANUAL_CODE_LENGTH;
/**
 * ARDIŞIK hatalı KISA KOD denemesi eşiği. Sayaç yalnız `manualCode` dalında
 * artar: jeton 192 bitliktir ve tahmin edilemez, oysa kısa kod 6 karakterdir —
 * kilit KÜÇÜK anahtar uzayını korur. Bir başarı sayacı sıfırlar.
 *
 * Bilinçli takas: kodu yanlış yazan gerçek kullanıcı da kilitlenir. Kilit
 * KISA (15 dk) ve kod okutma (QR) yolu ETKİLENMEZ; kilidin yanıtı da diğer
 * başarısızlıklarla aynıdır, yani kilidin varlığı dışarıdan ölçülemez.
 */
export const MANUAL_CODE_FAILURE_THRESHOLD = 5;
/** Ardışık hata sayacının penceresi — bu süre boyunca deneme gelmezse sıfırlanır. */
export const MANUAL_CODE_FAILURE_WINDOW_SECONDS = 900;
/**
 * Kilit süreleri (kademeli). Kilit tekrar tekrar tetiklenirse süre uzar;
 * dizinin sonuna gelindiğinde son değer kullanılır.
 */
export const MANUAL_CODE_LOCK_STEPS_SECONDS = [900, 1800, 3600];
/** Kaçıncı kilit olduğuna göre süre — 1'den başlar. */
export function manualCodeLockSeconds(strike) {
    const index = Math.min(Math.max(strike, 1), MANUAL_CODE_LOCK_STEPS_SECONDS.length) - 1;
    return MANUAL_CODE_LOCK_STEPS_SECONDS[index];
}
/**
 * ÇEVRİMDIŞI KUYRUK ANAHTARININ İKİNCİL DİZİNİ — YAŞAM SÜRESİ.
 *
 * `card_exchanges` satırı taraf başına TEK anahtar tutar ("ilk anahtar
 * kazanır"). Aynı çift için kuyrukta bekleyen İKİNCİ kalem (farklı anahtar) o
 * kolona yazılamaz; QA Blok 21 P3-1 bunun sonucunu ölçtü: teklif kapandıktan
 * sonra o kalem yeniden gönderilince İKİNCİ bir teklif açılıyordu — reddetmiş
 * olan tarafa. Anahtar bu yüzden ikincil bir dizinde (Redis) de tutulur.
 *
 * Süre, telefonun çevrimdışı kalabileceği makul en uzun aralığı kapsar; kalıcı
 * kayıt DEĞİLDİR (kalıcı olan kolondur) ve `noeviction` politikası altında
 * anahtarın TTL'siz bırakılmaması BullMQ işlerinin korunması için zorunludur.
 */
export const CARD_EXCHANGE_CLIENT_REQUEST_TTL_SECONDS = 86_400;
/**
 * AYIRT EDİLEMEZ RET — ZAMANLAMA TABANI (kabul kriteri).
 *
 * Ret gövdesi tek olsa bile YANIT SÜRESİ sızdırır: "jeton Redis'te yok" bir
 * okuma, "karşı taraf engellemiş" bir Redis + bir Postgres okumasıdır. Bütün
 * ret yolları bu tabana kadar bekletilir; ölçüm testte kanıtlanır.
 *
 * Yalnız BAŞARISIZ yola eklenir — başarılı akış yavaşlamaz.
 */
export const CARD_EXCHANGE_DENY_FLOOR_MS = 220;
/* ------------------------------------------------------------------------- *
 * DAMGANIN ALANI (Blok 22 — D10'un yazma yolu)
 * ------------------------------------------------------------------------- */
/**
 * KARŞILAŞMA ALANININ TOLERANSI.
 *
 * D10: damga serbest metin taşımaz — alan YALNIZCA organizatör kürasyonundan
 * (`meeting_areas`) gelebilir. Faz 2'de kürasyona bağlanan tek olgu KABUL
 * EDİLMİŞ görüşmenin slotudur (`meeting_request_slots.meeting_area_id`), o
 * yüzden damganın alanı oradan TÜRETİLİR: aynı çift, aynı etkinlik, kabul
 * edilmiş görüşme, slotun zaman penceresi.
 *
 * Tolerans pencereyi iki yönde genişletir — görüşme sarkar, kartlar çıkışta
 * değişilir. Tolerans DIŞINDA alan YAZILMAZ: "Fuaye'de tanıştınız" cümlesi
 * tahmin değil, olgu olmalıdır (uydurma veri yasağı).
 *
 * 1800 NEREDEN GELİYOR (tech-lead Orta: "saf yargı" — doğru, ve yargı olduğu
 * yazılı olsun):
 *  - Ölçüme dayanmıyor: üretim verisi yok, referansta ve D10'da bir sayı yok.
 *  - Ürün kuralına BAĞLANIYOR: görüşme uzunluğu üründe seçilebilen bir olgudur
 *    ve kümesi `MEETING_DURATION_MINUTES` = [15, 30, 45] dakikadır. Tolerans o
 *    kümenin ORTA değeri (30 dk = 1800 sn) seçildi: bir görüşme boyu erken
 *    gelmek ya da bir görüşme boyu sarkmak aynı buluşmanın parçası sayılır,
 *    daha fazlası ayrı bir olaydır. Yani sayı keyfî bir yuvarlama değil, ürünün
 *    kendi zaman birimidir — ama hangi birimin seçileceği YARGIDIR.
 *  - VARSAYIM: kartlar buluşmanın kendisinde ya da hemen bitiminde değişilir.
 *    Varsayım yanlışsa maliyet ASİMETRİKTİR — pencere geniş tutulursa yanlış
 *    alan atoma yazılır ve geri alınamaz, dar tutulursa alan boş kalır ve
 *    sonraki buluşmada dolabilir. Bu yüzden sayı büyütülecekse ÖLÇÜMLE
 *    büyütülmeli; küçültmek her zaman güvenli yöndür.
 *  - Değiştirmek TEK YERDEN: bu sabit + `findCuratedMeetingArea`. Kural
 *    `card-exchange-stamp-area.e2e-spec` ile iki yönden de pinlidir (sabiti
 *    küçültmek de büyütmek de testi kırar).
 */
export const ENCOUNTER_AREA_GRACE_SECONDS = 1800;
//# sourceMappingURL=card-exchange.js.map